const initRotatingHeadingComponent = () => {
    let flickitySlidersArray;
    if (window.innerWidth <= 819) {
        //if mobile, do something different ( if needed )
        flickitySlidersArray = initCarousel("[data-rotating-heading-component-slider] [data-slider]", cellAlign.center, true, false, true, false, true);
    }
    else {
        flickitySlidersArray = initCarousel("[data-rotating-heading-component-slider] [data-slider]", cellAlign.center, true, false, true, false, false);
    }
    flickitySlidersArray.forEach(flickitySlider => {
        const prevButton = flickitySlider.slider.closest("[data-rotating-heading-component-slider]").querySelector("[data-prev-button]");
        //custom binding to prev button
        prevButton.addEventListener("click", () => {
            flickitySlider.previous();
        });
        //custom binding to next button
        const nextButton = flickitySlider.slider.closest("[data-rotating-heading-component-slider]").querySelector("[data-next-button]");
        nextButton.addEventListener("click", () => {
            flickitySlider.next();
        });
        const addPreviousAndNextClassesToSlides = () => {
            const slidesArray = flickitySlider.slider.querySelectorAll("[data-slide]");
            // remove all "previous-slide" classes
            slidesArray.forEach(slide => slide.classList.remove("previous-slide"));
            //set previous slide class
            if (flickitySlider.selectedElement.previousElementSibling == null) {
                const previousElement = slidesArray[flickitySlider.cells.length - 1];
                previousElement.classList.add("previous-slide");
            }
            else {
                flickitySlider.selectedElement.previousElementSibling.classList.add("previous-slide");
            }
            // remove all "next-slide" classes
            slidesArray.forEach(slide => slide.classList.remove("next-slide"));
            if (flickitySlider.selectedElement.nextSibling == null) {
                const nextElement = slidesArray[0];
                nextElement.classList.add("next-slide");
            }
            else {
                flickitySlider.selectedElement.nextElementSibling.classList.add("next-slide");
            }
        };
        flickitySlider.on('change', addPreviousAndNextClassesToSlides);
        //first run only
        addPreviousAndNextClassesToSlides();
    });
};
